export default "__VITE_ASSET__9d78555d__"